"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGtmScript = void 0;
const consent_1 = require("../consent");
const useGtmScript = (gtmId) => {
    const decodedCookie = (0, consent_1.readConsentFromCookie)();
    const defaultGtmCookie = `
        window.dataLayer = window.dataLayer || [];
        if (typeof gtag !== "function") { function gtag(){dataLayer.push(arguments)}; }
        gtag("consent", "default", {
            'analytics_storage': '${decodedCookie.analytics_storage ? "granted" : "denied"}',
            'ad_storage': '${decodedCookie.ad_storage ? "granted" : "denied"}',
            'personalization_storage': '${decodedCookie.personalization_storage ? "granted" : "denied"}'}
        );`;
    return (defaultGtmCookie +
        `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`);
};
exports.useGtmScript = useGtmScript;
